import {Theme, createStyles} from '@material-ui/core';
import {cyan, grey, indigo, orange, pink, red, yellow, purple} from '@material-ui/core/colors';

export const technologiesStyles = (theme: Theme) => {
	const common = {
		marginBottom: theme.spacing(2),
		width: theme.spacing(7.5),
		height: theme.spacing(7.5),
	};

	return createStyles({
		javascript: {
			color: theme.palette.getContrastText(yellow[500]),
			backgroundColor: yellow[500],
			...common,
		},
		react: {
			color: theme.palette.getContrastText(cyan['A400']),
			backgroundColor: cyan['A400'],
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(8),
				height: theme.spacing(8),
			},
		},
		reactNative: {
			color: cyan['A400'],
			backgroundColor: theme.palette.common.black,
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(8),
				height: theme.spacing(8),
			},
		},
		nextJs: {
			color: theme.palette.common.black,
			backgroundColor: theme.palette.common.white,
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(8),
				height: theme.spacing(8),
			},
		},
		docker: {
			color: cyan[600],
			backgroundColor: grey[200],
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(5.5),
				height: theme.spacing(5.5),
			},
		},
		nestJs: {
			color: red[600],
			backgroundColor: theme.palette.common.black,
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(4.5),
				height: theme.spacing(4.5),
			},
		},
		webRtc: {
			backgroundColor: grey[200],
			...common,
			'& .svg-icon': {
				width: theme.spacing(4.5),
				height: theme.spacing(4.5),
			},
		},
		redux: {
			color: theme.palette.getContrastText(purple[700]),
			backgroundColor: purple[700],
			...common,
			'& .svg-icon': {
				width: theme.spacing(4),
				height: theme.spacing(4),
			},
		},
		electronJs: {
			color: cyan['A400'],
			backgroundColor: theme.palette.common.black,
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(4.5),
				height: theme.spacing(4.5),
			},
		},
		graphql: {
			color: theme.palette.getContrastText(pink['A400']),
			backgroundColor: pink['A400'],
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(4.5),
				height: theme.spacing(4.5),
			},
		},
		php: {
			color: theme.palette.getContrastText(indigo[300]),
			backgroundColor: indigo[300],
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(5),
				height: theme.spacing(5),
				marginLeft: theme.spacing(0.5),
			},
		},
		laravel: {
			color: theme.palette.getContrastText(red[600]),
			backgroundColor: red[600],
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(5),
				height: theme.spacing(5),
				marginLeft: theme.spacing(0.5),
			},
		},
		mysql: {
			color: theme.palette.getContrastText(cyan[900]),
			backgroundColor: cyan[900],
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(4),
			},
		},
		redis: {
			color: theme.palette.getContrastText(theme.palette.common.black),
			backgroundColor: theme.palette.common.black,
			...common,
			'& .svg-icon': {
				width: theme.spacing(5),
				height: theme.spacing(5),
				marginLeft: theme.spacing(0.75) - 1,
			},
		},
		elastic: {
			backgroundColor: grey[300],
			...common,
			'& .svg-icon': {
				width: theme.spacing(4.5),
				height: theme.spacing(4.5),
			},
		},
		rabbit: {
			color: theme.palette.getContrastText(orange[900]),
			backgroundColor: orange[900],
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(3.5),
				height: theme.spacing(3.5),
			},
		},
		lemp: {
			color: theme.palette.getContrastText(yellow[900]),
			backgroundColor: yellow[600],
			...common,
			'& .svg-icon': {
				fill: 'currentColor',
				width: theme.spacing(4),
			},
		},
	})
};
